import { GET_BPM_ROLE_ASSIGNMENT_LIST } from "@/modules/admin-panel/features/bpm-roles/list";
import { useMutation } from "@apollo/client";
import { REMOVE_BPM_ROLE_ASSIGNMENT } from "../api/remove-bpm-role-assignment";

export function useBpmRoleRemove() {
  const [removeBpmRole] = useMutation(REMOVE_BPM_ROLE_ASSIGNMENT, {
    refetchQueries: [GET_BPM_ROLE_ASSIGNMENT_LIST],
  });

  const remove = async (id: string) => {
    await removeBpmRole({
      variables: { id },
    });
  };

  return {
    remove,
  };
}
